import React, {Component} from 'react';
import FilterGenerateListWithImage from '../parts/FilterGenerateListWithImage';
import Axios from 'axios';
import APIENDPOINT from '../ApiEndpoint';
//

class Breinwaarde extends Component {
    constructor(props){
        super(props);
        this.state = {
            types: [],
            typesfull: [],
            filterOptions: []
        }
    }
    
    async componentDidMount(){
        const {data} = await Axios.get(`${APIENDPOINT}/types`);

        this.setState({typesfull : [...data] });
    }

    

    findFilterOptions = (needle) => {
        if(this.state.typesfull.length > 0){
            let filtersOptionsValues = [];
            const typeOptions = this.state.typesfull.find(type => type.type_name === needle).options;

            if(localStorage.getItem('didactisch-principe')){
                const didac = localStorage.getItem('didactisch-principe').split("&").slice(0, -1);
                if(didac.length > 0){
                    didac.forEach((el) => {
                        filtersOptionsValues.push(el);
                    });
                }
            }

            if(filtersOptionsValues.length > 0){
                return typeOptions.filter((option) => {
                    if(filtersOptionsValues.includes(option.didactic[0].option_name)){
                        return true;
                    }
                });
            }else{
                return typeOptions;
            }
            

        }else{
            return [];
        }
    }
    render(){
        const filterOptionImages = ["img/structuur-illustratie_2x.png", "img/actief-illustratie_2x.png", "img/zelfmanagement-illustratie_2x.png", "img/samenwerking-illustratie_2x.png", "img/groeigerichtheid-illustratie_2x.png"];
        const filtersOptions = this.findFilterOptions("Breinwaarde");
     
        return(
            <FilterGenerateListWithImage title='Selecteer een breinwaarde' filterOptionImages={filterOptionImages} filterOptions={filtersOptions}/>
        )
    }
}

export default Breinwaarde;